export const Contactusbanner = () => {
    return (
        <div className="servicecenter">
	 <div className="container">
	 	<div className="row">
	 		<div className="col-md-12">

              <div className="servicelocaiton">
                <h2>Contact Us:</h2>
                <p>Whether you need routine maintenance or emergency repairs, Apex Water Solutions is your trusted partner for RO repair in Delhi-NCR. Contact us today at 18005712070 or visit our website to schedule an appointment. Let us help you ensure your family or business enjoys clean and safe drinking water every day.</p>

					<p>Ensure the health and safety of your loved ones with RO Care Service in Delhi-NCR. Trust us for reliable RO repair solutions tailored to your needs. Our Ro Installation Charge is Normal 299/- Call Any Time 18005712070</p>
                {/* <h4>Email Us:</h4>
                <p><a href="mailto: book.aquacareroservice@gmail.com">book.aquacareroservice@gmail.com</a></p> */}
              </div>
	 		</div>
	 	
	 	 
	 </div>
    </div>
</div>
    )
}